import { render, staticRenderFns } from "./GettingStarted-fr.vue?vue&type=template&id=352b13f8&"
import script from "./GettingStarted-fr.vue?vue&type=script&lang=js&"
export * from "./GettingStarted-fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports